import { put } from 'redux-saga/effects';
import { publishVideoSuccessAction } from '../actions';
import { errorHandleAction } from 'components/error-handle/actions';
import { updateVideoApi } from 'common/api';

export function* publishVideoRequestEffect({ payload }) {
  try {
    const { videoId, title, description, keywords, channels, languages, countries, thumbnail } =
      payload.uploadVideoObject;
    let postData = {
      id: videoId,
      keywords,
      title,
      description,
      channels,
      languages,
      countries,
    };

    if (thumbnail) {
      postData = {
        ...postData,
        thumbnail,
      };
    }

    const uploadObj = yield updateVideoApi(videoId, postData);
    yield put(publishVideoSuccessAction(uploadObj));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
